import React from "react";
import { HiMenuAlt1 } from "react-icons/hi";
import { IoMdSettings } from "react-icons/io";
import UserIcon from "../Assets/Icons/user_Icon.png";
import { Button } from "@mui/material";

const Header = ({ setIsOpen }) => {
  const handleExpand = () => {
    setIsOpen(true);
  };
  return (
    <div className="header-container">
      <div className="header-wrapper">
        <Button onClick={() => handleExpand()}>
          <HiMenuAlt1 size={28} />
        </Button>
        <div>
          {/* right row grid row starts here */}
          <div className="header-right-grid-row">
            <div>
              <img src={UserIcon} alt="" />
              <div>
                <p>Arlene McCoy</p>
                <Button>LOGOUT</Button>
              </div>
            </div>
            <div>
              <IoMdSettings size={28} />
            </div>
          </div>
          {/* right row grid row ends here */}
        </div>
      </div>
    </div>
  );
};

export default Header;
